import { AxiosError } from 'axios';
import { createQueryKeys } from '@lukemorales/query-key-factory';
import { planApis } from '../../apis/plan/apis';
import type { IGetDevicePlanDetailParams, IGetPlansParams } from '../../apis/plan/types';
import type { AxiosCommonError } from '../../types';
import type { IPlanListResponse, IServicePlan } from '../../types/plan';

export const plansQueries = createQueryKeys('plans', {
  list: (params: IGetPlansParams) => ({
    queryKey: [params.pg, params.pgSize, params.searchCategory, params.keyword],
    queryFn: async (): Promise<{ data: IPlanListResponse }> => {
      const response = await planApis.getDevicePlans(params);
      return response.data;
    },
  }),
  planDetails: (params: IGetDevicePlanDetailParams) => ({
    queryKey: [params.id],
    queryFn: async (): Promise<{ data: IServicePlan } | null> => {
      try {
        const response = await planApis.getDevicePlanDetail(params);

        return response.data;
      } catch (error) {
        const axiosError = error as AxiosError<AxiosCommonError>;

        if (axiosError.response?.status === 404) {
          return null;
        }

        throw error;
      }
    },
  }),
});
